import firebase from 'firebase'
import 'firebase/firestore'

console.log(`FB CONFIG: ${process.env.VUE_APP_FIREBASE_CONFIG.projectId}`)
firebase.initializeApp(process.env.VUE_APP_FIREBASE_CONFIG)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const authUser = auth.currentUser
const authModule = firebase.auth

// firebase collections
const usersCollection = db.collection('users')
const eventsCollection = db.collection('events')

export {
    db,
    auth,
    authUser,
    authModule,
    usersCollection,
    eventsCollection
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js